import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getNotificationViewRequest = {};
var _getNotificationViewResponse = {};
var _getSetupRequest = {};
var _getSetupResponse = {};
var _missedBookingRequest = {};
var _missedBookingResponse = {};
var _pricingPlanErrorRequest = {};
var _pricingPlanErrorResponse = {};
var _setupRequest = {};
var _setupResponse = {};
var _waitingListSlotRequest = {};
var _waitingListSlotResponse = {};
function resolveComWixBookingsNotificationsApiV1NotificationsSettingsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/notifications-server',
                destPath: '',
            },
        ],
        'bookings._base_domain_': [
            {
                srcPath: '/notifications',
                destPath: '',
            },
            {
                srcPath: '/internal/notifications-server',
                destPath: '/internal',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/notifications-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/notifications-server',
                destPath: '',
            },
        ],
        _base_domain_: [
            {
                srcPath: '/_api/notifications-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/notifications-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** setup notifications */
export function setup(payload) {
    var _a = serializer(_setupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setupResponse, {}).fromJSON;
    function __setup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.notifications.v1.notifications_settings',
            method: 'PATCH',
            methodFqn: 'com.wix.bookings.notifications.api.v1.NotificationsSettings.Setup',
            url: resolveComWixBookingsNotificationsApiV1NotificationsSettingsUrl({
                protoPath: '/v1/notifications',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setup.fromReq = fromReq;
    __setup.__isAmbassador = true;
    return __setup;
}
/** Return the checkout details */
export function get(payload) {
    var _a = serializer(_getSetupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSetupResponse, {}).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.notifications.v1.notifications_settings',
            method: 'GET',
            methodFqn: 'com.wix.bookings.notifications.api.v1.NotificationsSettings.Get',
            url: resolveComWixBookingsNotificationsApiV1NotificationsSettingsUrl({
                protoPath: '/v1/notifications',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
export function getNotificationView(payload) {
    var _a = serializer(_getNotificationViewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getNotificationViewResponse, {}).fromJSON;
    function __getNotificationView(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.notifications.v1.notifications_settings',
            method: 'GET',
            methodFqn: 'com.wix.bookings.notifications.api.v1.NotificationsSettings.GetNotificationView',
            url: resolveComWixBookingsNotificationsApiV1NotificationsSettingsUrl({
                protoPath: '/v1/notificationsView',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getNotificationView.fromReq = fromReq;
    __getNotificationView.__isAmbassador = true;
    return __getNotificationView;
}
export function missedBooking(payload) {
    var _a = serializer(_missedBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_missedBookingResponse, {}).fromJSON;
    function __missedBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.notifications.v1.notifications_settings',
            method: 'POST',
            methodFqn: 'com.wix.bookings.notifications.api.v1.NotificationsSettings.MissedBooking',
            url: resolveComWixBookingsNotificationsApiV1NotificationsSettingsUrl({
                protoPath: '/v1/notifications/missedBooking',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __missedBooking.fromReq = fromReq;
    __missedBooking.__isAmbassador = true;
    return __missedBooking;
}
export function pricingPlanError(payload) {
    var _a = serializer(_pricingPlanErrorRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_pricingPlanErrorResponse, {}).fromJSON;
    function __pricingPlanError(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.notifications.v1.notifications_settings',
            method: 'POST',
            methodFqn: 'com.wix.bookings.notifications.api.v1.NotificationsSettings.PricingPlanError',
            url: resolveComWixBookingsNotificationsApiV1NotificationsSettingsUrl({
                protoPath: '/v1/notifications/invalidPricingPlanSetup',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __pricingPlanError.fromReq = fromReq;
    __pricingPlanError.__isAmbassador = true;
    return __pricingPlanError;
}
export function waitingListSlot(payload) {
    var _a = serializer(_waitingListSlotRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_waitingListSlotResponse, {}).fromJSON;
    function __waitingListSlot(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.notifications.v1.notifications_settings',
            method: 'POST',
            methodFqn: 'com.wix.bookings.notifications.api.v1.NotificationsSettings.WaitingListSlot',
            url: resolveComWixBookingsNotificationsApiV1NotificationsSettingsUrl({
                protoPath: '/v1/notifications/waitinListSlot',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __waitingListSlot.fromReq = fromReq;
    __waitingListSlot.__isAmbassador = true;
    return __waitingListSlot;
}
//# sourceMappingURL=http.impl.js.map